<template>
  <div id="app"  :class='onlinestate=="pc"?"":"look_id"'>
    <div :class='islang=="eng"&&onlinestate !=="pc"?"look_en":""'>
    <!-- <router-view v-wechat-title='$route.meta.title_en + " | QMIS Financial Group"' v-if="islang == 'eng'"/>
    <router-view v-wechat-title='$route.meta.title_ch + " | 華亞金融集團"' v-else/> -->
    <router-view />
    <div style="width: 100vw;height: 100vh;background-color: #fff;z-index: 2000;" v-if='$store.state.island'></div>
    </div>
  </div>
</template>

<script>
  document.onkeydown = () => {
    //禁用F12
    if (window.event && window.event.keyCode == 123) {
      return false;
    //禁用ctrl+ c,
    } else if (window.event.ctrlKey  && window.event.keyCode == 67) {
      return false;
    } else if(window.event.keyCode == 67 && window.event.metaKey){
      return false;
    }else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
      return false;
    }else if (window.event.metaKey && window.event.shiftKey && window.event.keyCode == 73) {
      return false;
    }else if (window.event.shiftKey && window.event.keyCode == 121) {
      return false;
    }
  };
export default {
  name: 'App',
  data(){
    return{
      onlinestate:sessionStorage['onlinestate'],
      islang: window.localStorage.guanwanglang,
    }
  },
  // created() {
  //   if (navigator.share) {

  //     window.addEventListener('share', this.handleShare);
  //   }
  // },
  // destroyed() {
  //   if (navigator.share) {
  //     window.removeEventListener('share', this.handleShare);
  //   }
  // },
  mounted() {
    if (window.localStorage.guanwanglang == 'undefined') {
      window.localStorage.guanwanglang = 'big5'
    }
    document.oncontextmenu = new Function("event.returnValue=false");
    // window.onresize = function () {
    //   location.reload()
    // }
    window.localStorage.guanwanglang = window.localStorage.guanwanglang
    if(location.href.split('?lang=')[1]){
      let strlang = location.href.split('?lang=')[1];
      console.log(strlang , '---------------+++')
      if(window.localStorage.guanwanglang !== strlang){
        window.localStorage.guanwanglang = strlang
        setTimeout(()=>{
          location.reload();
        },200)
      }
    }

  },
  // methods: {
  //   share() {
  //     if (navigator.share) {
  //       // navigator.share({
  //       //   title: '分享标题',
  //       //   text: '分享文本',
  //       //   url: 'https://example.com'
  //       // })
  //       //   .then(() => console.log('分享成功'))
  //       //   .catch((error) => console.log('分享失败', error));
  //       console.log(this.islang);
  //       alert(123+this.islang)
  //     }
  //   },
  //   handleShare(event) {
  //     console.log('分享事件', event);
  //   }
  // }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  /* font-family: 微軟正黑體, sans-serif !important; */
}

  @media screen and (max-width: 1100px) {
    #app {
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue